<template>
  <div class="dcf-grid dcf-row-gap-5 dcf-col-gap-5">
    <div class="dcf-col-100%">
      <div class="dcf-form dcf-d-flex">
        <div class="dcf-input-radio dcf-mr-2">
          <input type="radio" id="scientific" value="scientific" v-model="nameDisplay">
          <label for="scientific">Scientific Name</label>
        </div>
        <div class="dcf-input-radio">
          <input type="radio" id="common" value="common" v-model="nameDisplay">
          <label for="common">Common Name</label>
        </div>
      </div>
    </div>

    <div class="dcf-col-100% dcf-col-25%-start@md">
      <div class="unl-font-sans unl-bg-lightest-gray dcf-p-2 bov-list">
        <ul class="dcf-list-bare dcf-txt-sm" v-if="musclesLoaded">
          <template v-for="muscle in sortedMuscles">
            <li :class="(activeMuscleId == muscle.id) ? 'dcf-pl-1 active' : 'dcf-pl-1 '" v-if="(nameDisplay == 'scientific' && muscle.name != '') || (nameDisplay == 'common' && muscle.common_name != '')">
              <a class="dcf-txt-decor-none" href="#" v-on:click.prevent="activeMuscleId = muscle.id" v-text="(nameDisplay == 'scientific') ? muscle.name : muscle.common_name"></a>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="dcf-col-100% dcf-col-75%-end@md" v-if="activeMuscleId">
      <muscle :muscle="activeMuscle" :profiles="profiles"></muscle>
    </div>
  </div>

</template>

<style>
.bov-list {
  height: 600px;
  overflow: auto;
}

.bov-list .active {
  background: #d00000;
}

.bov-list .active a {
  color: #fefdfa;
}

@media (max-width: 640px) {
  .bov-list {
    height: 20vh;
  }
}

</style>

<script>
import fetchData from '../includes/fetchData.js';
import muscle from './muscle.vue';

export default {
  components: { muscle },
  mixins: [ fetchData ],
  data: function(){
    return {
      muscles: [],
      musclesLoaded: false,
      profiles: [],
      activeMuscleId: false,
      nameDisplay: 'scientific'
    }
  },
  computed: {
    sortedMuscles: function(){
      var output = this.muscles;
      var sortType = this.nameDisplay;

      output = output.sort(function(a, b){
        var key = (sortType == 'scientific') ? 'name' : 'common_name';

        if(a[key].toUpperCase() < b[key].toUpperCase()){
          return -1;
        }
        if(a[key].toUpperCase() > b[key].toUpperCase()){
          return 1;
        }
        return 0;

      });

      return output;
    },
    activeMuscle: function(){
      var $this = this;
      return this.activeMuscleId ? this.muscles.find( function(v){ return v.id == $this.activeMuscleId }) : false;
    }
  },
  methods: {
    musclesFetched: function(data){
      this.muscles = data; 
      this.musclesLoaded = true;
    }
  },
  created: function(){
    this.fetchData('/muscles.json', this.musclesFetched, this.handleErrors);
    this.profiles = window.profiles;
  }
}
</script>

